import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, NavController, NavParams } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Navigator } from 'src/app/services/routing/navigator';
import { EMAIL_PATTERN } from "src/app/services/customFormValidators";

@Component({
  selector: 'app-reset-password-verify-first-step',
  templateUrl: './reset-password-verify-first-step.component.html',
  styleUrls: ['./reset-password-verify-first-step.component.scss'],
})
export class ResetPasswordVerifyFirstStepComponent implements OnInit {
  @ViewChild("Content") content: IonContent;

  public isComplete:boolean = false;
  public error: any = null;
  public step1Form: FormGroup;

  public email: AbstractControl;
  public pin: AbstractControl;
  private customerId = null;
  public showForm:boolean = true;
  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public authenticationProvider: AuthenticationService,
      public successMessageProvider: SuccessMessageService,
      public config: ConfigService,
      public utils: UtilsService,
      public navigator: Navigator
  ) {
      this.successMessageProvider.clearMessage();
  }

  ngOnInit() {

      this.step1Form = new FormGroup({
            email: new FormControl("", [Validators.pattern(EMAIL_PATTERN), Validators.required, Validators.maxLength(250)]),
            pin: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(4), Validators.pattern('^[0-9]*')]),
      });

      this.email = this.step1Form.get('email');
      this.pin = this.step1Form.get('pin');
      this.customerId = this.navParams.get("customerId");
  }

  resendPin() {
      this.successMessageProvider.clearMessage();
      this.error = null;      
      let clientapp = this.config.getClientApp();

      if(this.email.invalid){
        this.email.markAsTouched();
        this.email.markAsDirty();
        this.email.setErrors({ 'EMAIL_NOT_FOUND': true })
        this.content.scrollToTop();
    } else {
        this.authenticationProvider.callResendPin(this.email.value, clientapp).subscribe(
            (response) => {
                this.isComplete = true; 
            },
            (error) => {
                this.isComplete = true;
            }
        );
    }  
  }

  onSubmit() {

      this.successMessageProvider.clearMessage();
      this.isComplete = false;
      this.error = null;
      this.step1Form.value.clientapp = this.config.getClientApp();

      this.authenticationProvider.callResetPasswordStep1(this.step1Form.value).subscribe(
          (response: any) => {
              if (response && !!response.result) { 
                  this.navigator.navigateTo("ResetPasswordVerifySecondStepComponent", {}, { email: this.email.value, pin: this.pin.value, customerId: this.customerId });
              }
          },
          (error) => {                

              switch (error.getErrorCode().toUpperCase()) {
                  case 'EMAIL_NOT_FOUND':
                      this.isComplete = true;
                      //error.setErrorMessage("Your email wasn't found. Please enter the email address that you registered with.");
                      this.email.markAsTouched();
                      this.email.markAsDirty();
                      this.email.setErrors({ 'EMAIL_NOT_FOUND': true })
                      break;
                  case 'INVALID_PIN':
                      this.error = error;
                      error.setErrorMessage("The PIN didn't match with the email address entered. Please try again.");
                      this.pin.markAsTouched();
                      this.pin.markAsDirty();
                      this.pin.setErrors({ 'INVALID_PIN': true })
                      break;
                  case 'SECURE_MAX_ATTEMPTS_REACHED':
                    error.setErrorMessage(error.getErrorMessage());
                    this.showForm = false;
                    break;
                  default:
                      this.showForm = true;
                      error.setErrorMessage(error.getErrorMessage());
              }
              this.successMessageProvider.clearMessage();
              this.content.scrollToTop();
          }
      );
  }
}
